import { render } from "./DeleteLinkButton.vue?vue&type=template&id=8350fd76&scoped=true"
import script from "./DeleteLinkButton.vue?vue&type=script&lang=js"
export * from "./DeleteLinkButton.vue?vue&type=script&lang=js"

import "./DeleteLinkButton.vue?vue&type=style&index=0&id=8350fd76&lang=less&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/00-client-web(prod)/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8350fd76"]])

export default __exports__